import { mapState } from 'vuex'
import _ from 'lodash'
import TheBreadcrumbs from '@/components/common/TheBreadcrumbs/TheBreadcrumbs'
import DataTable from '@/components/common/DataTable/DataTable'
import AnalyzeCondition from '@/components/common/Result/AnalyzeCondition/AnalyzeCondition'
import ResultDetail from '@/components/common/Result/ResultDetail/ResultDetail'
import Constants from '@/utils/Constants'
import moment from 'moment-timezone'
import VueScrollTo from 'vue-scrollto'
import chartOptionUtil from '@/store/result/utils/chartoption'
import Vue from 'vue'

export default {
  name: 'PageSetting',
  layout: 'LayoutDefault',
  components: {
    TheBreadcrumbs: TheBreadcrumbs,
    DataTable: DataTable,
    AnalyzeCondition: AnalyzeCondition,
    ResultDetail: ResultDetail
  },
  data: () => ({
    tab: null,
    showCondition: false,
    selectedConditionjp: null,
    memberGroup: {
      tagName: '',
      name: '',
      publishSetting: 1
    },
    showLockMemberGroup: false,
    headerFlag: true,
    mailFlag: false,
    tabName: 'area',
    oldPagination: null,
    activeTab: null,
    yAxis: ''
  }),
  created () {
    this.init()
    // this.$store.dispatch('analyzeresult/getHistoryData', this.$route.params.historyId)
  },
  computed: {
    breadcrumbs () {
      return [
        {
          text: 'ダッシュボード',
          disabled: false,
          href: '/'
        },
        {
          text: this.historyData.analyze_target_name,
          disabled: false,
          href: '/analyze/' + this.analyzeTargetCode
        },
        {
          text: this.title + ' 結果',
          disabled: true,
          href: ''
        }
      ]
    },
    ...mapState('analyzeresult', {
      initLoaded: state => state.initLoaded,
      isListLoading: state => state.isListLoading,
      headers: state => state.headers,
      labelOverMaxItems: state => state.labelOverMaxItems,
      vtColumns: state => state.vtColumns,
      vtOptions: state => state.vtOptions,
      items: state => state.items,
      historyData: state => state.historyData,
      analyzeTargetCode: state => state.historyData.analyze_target_code,
      jobId: state => state.historyData.job_id,
      graphSetting: state => state.historyData.graph_setting,
      memo: state => state.historyData.memo,
      title: state => state.historyData.analyze_target_name,
      conditions: state => state.historyData.conditions,
      condition_jp: state => state.historyData.condition_jp,
      tabs: state => state.historyData.tabs,
      message: state => state.message,
      ages: state => state.ages
    }),
    title () {
      if (this.analyzeTargetCode === 'IF00007' && this.condition_jp && typeof this.condition_jp.type_mode !== 'undefined') {
        switch (this.condition_jp.type_mode) {
          case 0:
            return '併買分析（期間併買）'
          case 1:
            return '併買分析（直前）'
          case 2:
            return '併買分析（直後）'
          default:
            return this.historyData.analyze_target_name
        }
      }
      return this.historyData.analyze_target_name
    },
    ...mapState('routerdata', {
      menuItem: state => state.menuItem,
      data: state => state.data
    }),
    ...mapState('chartdata', {
      tabType: state => state.tabType
    }),
    showTab () {
      if (!this.tabs || this.tabs.length === 0) {
        return false
      }
      return true
    },
    showButtons () {
      return this.historyData.user_id === Constants.getUser('id')
    },
    detailList () {
      if (this.analyzeTargetCode === 'IF00016' || this.analyzeTargetCode === 'IF00017') {
        const a = moment(this.historyData.analyze_timestamp).tz('Asia/Tokyo').format('YYYYMMDDHHmmss')
        return [`${this.historyData.job_id}/DL_${a}.csv.zip`]
      }
    }
  },
  watch: {
    message (msg) {
      if (msg.type) {
        this.g_addAlert(msg.content, msg.type, msg.type === 'error' ? 0 : 5)
      }
    }
  },
  destroyed () {
    this.$store.dispatch('analyzeresult/resetData')
  },
  methods: {
    init () {
      // if (this.showTab) {
      //   this.activeTab = null
      // }
      this.$store.dispatch('analyzeresult/initData', this.$route.params.historyId)
    },
    onExportReport (exportType) {
      let chartObject = exportType === 1 ? null : this.getChart(this.analyzeTargetCode, this.tabType)
      let param = {
        type: this.tabType,
        header_need: this.headerFlag ? '1' : '0',
        mail_need: this.mailFlag ? '1' : '0',
        export_type: exportType || 2
      }
      this.$store.dispatch('analyzeresult/exportReport',
        { param: param, chartObject: chartObject })
    },
    getChart (analyzeTargetCode, tabKey) {
      if (this.graphSetting === 1) {
        // タブありの分析
        if (this.hasChartInTab(analyzeTargetCode)) {
          let resultDetailIndex = -1
          if (!tabKey) {
            resultDetailIndex = 0
          } else {
            const analyzeObject = this.tabs
            const tab = _.filter(analyzeObject, tabItem => {
              return tabItem.key === tabKey
            })
            if (tab && tab.length === 1) {
              resultDetailIndex = tab[0].index
            }
          }
          if (resultDetailIndex !== -1) {
            if (analyzeTargetCode === 'IF00002') {
              return this.$refs.resultDetail[resultDetailIndex].$refs.lineChart[0].$refs.highcharts.chart
            } else {
              if (_.isArray(this.$refs.resultDetail)) {
                if (this.$refs.resultDetail[resultDetailIndex].$refs.lineChart) {
                  // /chart_dataからデータありの場合のみ画面上チャートあり
                  return this.$refs.resultDetail[resultDetailIndex].$refs.lineChart.$refs.highcharts.chart
                }
              } else {
                return this.$refs.resultDetail.$refs.lineChart.$refs.highcharts.chart
              }
            }
          }
        } else {
          if (this.$refs.resultDetail.$refs && this.$refs.resultDetail.$refs.lineChart) {
            // タブなしの分析
            return this.$refs.resultDetail.$refs.lineChart.$refs.highcharts.chart
          }
        }
      }
      return null
    },
    hasChartInTab (analyzeTargetCode) {
      if (this.tabs && this.tabs.length > 0) {
        return chartOptionUtil.hasChartByTabs(analyzeTargetCode, this.tabType)
      }
      return false
    },
    onExportItems (exportItem) {
      let param = {
        export_type: exportItem.type,
        code_pattern: exportItem.code_pattern
      }
      this.$store.dispatch('analyzeresult/exportItems', param)
    },
    onShowLockMember () {
      this.showLockMemberGroup = !this.showLockMemberGroup
    },
    exposeCondition () {
      this.selectedConditionjp = this.condition_jp
      this.showCondition = !this.showCondition
    },
    onSaveMemberGroup () {
      this.$store.dispatch('analyzeresult/lockMemberGroup', this.memberGroup)
      this.showLockMemberGroup = !this.showLockMemberGroup
    },
    onChangeTab (index) {
      this.$store.commit('chartdata/setTabType', this.tabs[index].key)
      this.activeTab = this.tabs[index].key
      console.log('onChangeTab', this.activeTab)
      if (this.activeTab !== null) {
        if (chartOptionUtil.hasChartByTabs(this.analyzeTargetCode, this.activeTab)) {
          this.$store.dispatch('chartdata/getChartData', {
            targetCode: this.analyzeTargetCode,
            historyId: this.historyData.id,
            type: this.tabs[index].key,
            conditions: this.conditions,
            yAxis: this.analyzeTargetCode === 'IF00010' ? 'base_purchase_qty' : 'purchase_qty_composition_rate_card',
            ages: this.ages
          })
        }
        this.$store.dispatch('analyzeresult/getResultData', {
          targetCode: this.analyzeTargetCode,
          historyId: this.historyData.id,
          type: this.tabs[index].key,
          pageNo: null,
          pageSize: null
        })
      }
    },
    onReservation () {
      let path = '/analyze/'.concat(this.analyzeTargetCode)
      let routeTarget = {
        path: path,
        query: {
          history_id: this.$route.params.historyId,
          is_reservation: 1
        }
      }
      this.$router.push(routeTarget)
    },
    onAnalyze () {
      let path = '/analyze/'.concat(this.analyzeTargetCode)
      let routeTarget = {
        path: path,
        query: {
          history_id: this.$route.params.historyId
        }
      }
      this.$router.push(routeTarget)
    },
    onPagination (pagination) {
      console.log('pagination:', pagination)
      if (this.oldPagination != null) {
        if (this.oldPagination.page === pagination.page &&
          this.oldPagination.sortBy === pagination.sortBy &&
          this.oldPagination.descending === pagination.descending) {
          return
        }
      }
      this.oldPagination = _.cloneDeep(pagination)
      if (this.isInit) {
        this.init()
      } else {
        this.$store.dispatch('analyzeresult/getResultData', {
          targetCode: this.analyzeTargetCode,
          historyId: this.historyData.id,
          pageNo: null,
          pageSize: null,
          sortField: pagination.sortBy,
          sortType: pagination.descending,
          type: this.activeTab
        })
      }
      VueScrollTo.scrollTo('body', 500)
    },
    download (item) {
      this.$store.dispatch('analyzeresult/download', item).then(() => {
        if (this.message.type === 'error') {
          this.g_addAlert(this.message.content, this.message.type, 0)
        } else {
        }
      })
    },
    onRedrawChart (yAxis) {
      this.$store.dispatch('chartdata/getChartData', {
        targetCode: this.analyzeTargetCode,
        historyId: this.historyData.id,
        type: this.tabType,
        conditions: this.conditions,
        yAxis: yAxis,
        ages: this.ages
      })
    },
    canPublishGroup () {
      let canPublish = true
      const contract = JSON.parse(Vue.localStorage.get('contract'))
      if (!contract) {
        canPublish = false
      } else {
        canPublish = (contract.group_publish_setting_flag === 1)
      }
      if (!canPublish) {
        this.memberGroup.publishSetting = 0
      }
      return canPublish
    }
  },
  metaInfo () {
    this.$store.dispatch('meta/set', {
      title: this.title + ' ' + this.historyData.id,
      meta: [
        {
          name: 'description',
          content: '分析結果'
        }
      ]
    })
    return this.$store.getters['meta/get']
  }
}
